import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useCallback } from 'react';

const BULK_ISSUE_CREATE_SOURCE = 'confluenceBulkIssueCreate';

export const useBulkCreateLoggingEvents = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const logSingleIssueCreateSuccess = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendTrackEvent',
			data: {
				source: BULK_ISSUE_CREATE_SOURCE,
				action: 'created',
				actionSubject: 'issue',
				actionSubjectId: 'confluenceIssueCreate',
			},
		}).fire();
	}, [createAnalyticsEvent]);

	const logSingleIssueCreateFailure = useCallback(
		(error: Error | unknown) => {
			createAnalyticsEvent({
				type: 'sendTrackEvent',
				data: {
					source: BULK_ISSUE_CREATE_SOURCE,
					action: 'error',
					actionSubject: 'globalIssueCreate',
					attributes: {
						error,
					},
				},
			}).fire();
		},
		[createAnalyticsEvent],
	);

	return { logSingleIssueCreateSuccess, logSingleIssueCreateFailure };
};
